import React from 'react';
import { useQuery } from 'react-query';
import PropTypes from 'prop-types';

import { getWebcams } from '../../../services/dataset.service';
import { getLakeFromCoordinates } from '../../../utils';
import WebCam from './WebCam';

const WebCams = ({ selectedLake }) => {
  const {
    data: webcamData,
  } = useQuery(
    'WEBCAM_DATA',
    getWebcams,
  );

  if (!webcamData || webcamData.length === 0) {
    return null;
  }

  const mappableWebcams = webcamData.filter(
    (wc) => wc?.external_asset?.data?.properties?.location?.coordinates,
  );

  const visibleWebcams = selectedLake
    ? mappableWebcams.filter((webcam) => {
      const [lng, lat] = webcam.external_asset.data.properties.location.coordinates;
      return getLakeFromCoordinates(lng, lat) === selectedLake;
    })
    : mappableWebcams;

  return (
    <>
      {visibleWebcams.map((webcam, i) => (
        <WebCam webcam={webcam} key={i} />
      ))}
    </>
  );
};

WebCams.propTypes = {
  selectedLake: PropTypes.string,
};

WebCams.defaultProps = {
  selectedLake: '',
};

export default WebCams;
